export { CairoProvider as WixPatternsProvider } from '../../dashboard/CairoProvider';
export { CairoProviderProps as WixPatternsProviderProps } from '../../dashboard/CairoDashboardBaseProvider';
